import translations from '../translations';

export default function basketFormInit() {

    function getCurrentLanguage() {
        var siteLanguage = '';

        switch (window.location.pathname.split('/')[1]) {
            case 'ru':
                siteLanguage = 'ru-RU';
                break;
            case 'en':
                siteLanguage = 'en-US';
                break;
            case 'pl':
                siteLanguage = 'pl-PL';
                break;
            case 'es':
                siteLanguage = 'es-ES';
                break;
            default:
                siteLanguage = 'uk-UA';
                break;
        }

        return siteLanguage;
    }

    function getLanguageForTranslations() {
        return getCurrentLanguage().split('-')[0];
    }

    function formatTemplate(template, value0) {
        return (template || '').replace('{0}', value0);
    }

    function parseStockLimit($input) {
        const fromInput = $input.attr('data-stock');
        if (fromInput !== undefined && fromInput !== null && fromInput !== '') {
            const v = parseInt(fromInput, 10);
            return Number.isFinite(v) ? v : null;
        }

        const $row = $input.closest('tr');
        const fromRow = $row.attr('data-stock');
        if (fromRow !== undefined && fromRow !== null && fromRow !== '') {
            const v = parseInt(fromRow, 10);
            return Number.isFinite(v) ? v : null;
        }

        return null;
    }

    $('.quantity').each(function () {
        var container = $(this);
        var minusButton = container.find('.minus-btn');
        var plusButton = container.find('.plus-btn');
        var inputField = container.find('input');
        var stockHint = container.next('.stock-hint');

        const MIN_QTY = 1;

        function showStockHint(max) {
            const lang = getLanguageForTranslations();
            const template = translations.maxStockOnly?.[lang] || translations.maxStockOnly.uk;
            stockHint.text(formatTemplate(template, max)).removeClass('hidden');
        }

        function hideStockHint() {
            stockHint.addClass('hidden');
        }

        function setDisabledStateForButtons(currentQty) {
            const maxStock = parseStockLimit(inputField);
            minusButton.toggleClass('disabled', currentQty <= MIN_QTY);

            if (maxStock === null) {
                plusButton.toggleClass('disabled', currentQty >= 100);
                hideStockHint();
            } else {
                plusButton.removeClass('disabled');
                if (currentQty < maxStock) hideStockHint();
            }
        }

        function clamp(val) {
            const maxStock = parseStockLimit(inputField);
            let v = parseInt(val, 10);
            if (!Number.isFinite(v)) v = MIN_QTY;
            v = Math.max(MIN_QTY, v);

            if (maxStock !== null) v = Math.min(maxStock, v);
            else v = Math.min(100, v);

            return v;
        }

        setDisabledStateForButtons(clamp(inputField.val()));

        function handleQuantityChange(rowId, handleValueFunc) {
            var mainRowId = rowId.replace('_discount', '');
            var mainRow = $(`#${mainRowId}`);

            if (!mainRow.length) {
                var token = $('input[name="__RequestVerificationToken"]').val();
                var currentUrl = window.location.href;

                $.ajax({
                    type: 'POST',
                    url: '/umbraco/Merchello/StoreBasket/AddBasketItem',
                    dataType: 'json',
                    data: {
                        productKey: mainRowId,
                        quantity: 1,
                        successRedirectUrl: currentUrl,
                        __RequestVerificationToken: token
                    },
                    success: function () {
                        window.location.reload();
                    },
                    error: function (xhr, status, error) {
                        console.error('Error when adding an item to cart:', status, error);
                    }
                });

                return;
            }

            var mainInput = mainRow.find('.quantity input');
            updateInputValue(mainInput, handleValueFunc);
        }

        function updateInputValue($input, handleValueFunc) {
            const maxStock = parseStockLimit($input);
            const oldValue = clamp($input.val());
            const candidate = handleValueFunc(oldValue);

            let newValue = candidate;

            if (maxStock !== null && candidate > maxStock) {
                newValue = maxStock;
            } else {
                newValue = clamp(candidate);
            }

            if (newValue !== oldValue) {
                $input.val(newValue).trigger('change');
                setDisabledStateForButtons(newValue);
            } else {
                setDisabledStateForButtons(oldValue);
            }
        }

        function updateQuantity(e, handleValueFunc) {
            var $this = $(e.target);
            var closestRow = $this.closest('tr');
            var rowId = closestRow.attr('id');

            if (rowId && rowId.endsWith('_discount')) {
                handleQuantityChange(rowId, handleValueFunc);
            } else {
                updateInputValue(inputField, handleValueFunc);
            }
        }

        minusButton.on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('disabled')) return;
            updateQuantity(e, (val) => val - 1);
        });

        plusButton.on('click', function (e) {
            e.preventDefault();
            const maxStock = parseStockLimit(inputField);
            if (maxStock !== null && clamp(inputField.val()) >= maxStock) {
                showStockHint(maxStock);
                return;
            }
            updateQuantity(e, (val) => val + 1);
        });
    });
}
